export interface ConsultingRoomData {
  id: number;
  name: string;
  size: number;
  assignedDoctors: number;
  description: string;
}

export const initialConsultingRoomData: ConsultingRoomData = {
  id: 0,
  name: "",
  size: 1,
  assignedDoctors: 0,
  description: "",
};
